/**
 * A régua de "sem interação": há quanto tempo ninguém fala com o negócio.
 *
 * Uma só para o produto inteiro (Oportunidades e Painel Operacional), decidido por ele em
 * 14/10/2026 ao pedir "quem está a mais de 2 dias sem interação": a Pipeline começava em 7 dias,
 * o Painel tinha 5 dias fixos no código, e o que ele queria não existia em lugar nenhum. Duas
 * réguas diferentes para a mesma pergunta fazem a mesma conversa aparecer parada numa tela e
 * atendida na outra.
 *
 * Os cortes curtos (24h, 2 e 3 dias) existem porque é nessa faixa que dá para reagir; os longos
 * continuam porque é onde mora o que foi esquecido de vez. Os valores gravados antes ('7 dias',
 * '15 dias', '30 dias', '60 dias') continuam valendo — a sessão de quem está com a tela aberta
 * não se perde.
 */
export const PARADOS = [
    { valor: '24h', dias: 1 },
    { valor: '2 dias', dias: 2 },
    { valor: '3 dias', dias: 3 },
    { valor: '7 dias', dias: 7 },
    { valor: '15 dias', dias: 15 },
    { valor: '30 dias', dias: 30 },
    { valor: '60 dias', dias: 60 },
] as const;

/** Quantos dias cheios o corte escolhido representa; nulo quando não há corte. */
export const diasDoCorte = (valor: string | null): number | null =>
    PARADOS.find(p => p.valor === valor)?.dias ?? null;
